// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__oCTyc","form":"styles_form__2iFuE","inputs":"styles_inputs__mM-v5","buttons":"styles_buttons__1QEwj"};